import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import axios from "axios";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";

const CompanyMasterCreate = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const companyId = location?.state?.companyId;
    const isEdit = location?.state?.isEdit;

    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        firstName: "",
        middleName: "",
        lastName: "",
        organizationName: "",
        gstNumber: "",
        email: "",
        alternateEmail: "",
        mobileNumber: "",
        alternateMobileNumber: "",
        gstType: "INTER_STATE",
        partyType: "CUSTOMER",
        active: true,
        address: {
            landMark: "",
            streetLine1: "",
            streetLine2: "",
            city: "",
            state: "",
            postalCode: "",
            country: "India",
            metadata: "",
            primaryAddress: true,
        },
    });

    // ================= INPUT CHANGE =================
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // ================= ADDRESS CHANGE =================
    const handleAddressChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            address: {
                ...prev.address,
                [name]: value,
            },
        }));
    };

    const fetchCompanyById = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("token");

            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/trading-partner/${companyId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const data = response.data;

            setFormData({
                firstName: data.firstName || "",
                middleName: data.middleName || "",
                lastName: data.lastName || "",
                organizationName: data.organizationName || "",
                gstNumber: data.gstNumber || "",
                email: data.email || "",
                alternateEmail: data.alternateEmail || "",
                mobileNumber: data.mobileNumber || "",
                alternateMobileNumber:
                    data.alternateMobileNumber || "",
                gstType: data.gstType || "INTER_STATE",
                partyType: data.partyType || "",
                active:
                    data.active !== undefined
                        ? data.active
                        : true,

                address: {
                    landMark:
                        data.address?.landMark || "",
                    streetLine1:
                        data.address?.streetLine1 || "",
                    streetLine2:
                        data.address?.streetLine2 || "",
                    city: data.address?.city || "",
                    state: data.address?.state || "",
                    postalCode:
                        data.address?.postalCode || "",
                    country:
                        data.address?.country || "India",
                    metadata:
                        data.address?.metadata || "",
                    primaryAddress:
                        data.address?.primaryAddress ??
                        true,
                },
            });
        } catch (error) {
            console.error(error);
            toast.error("Failed To Fetch Company");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isEdit && companyId) {
            fetchCompanyById();
        }
    }, [companyId, isEdit]);

    // ================= SUBMIT =================
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            const token = localStorage.getItem("token");

            if (isEdit) {
                await axios.patch(
                    `${process.env.REACT_APP_BACKEND_URL}/trading-partner/${companyId}`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type":
                                "application/json",
                        },
                    }
                );

                toast.success(
                    "Company Updated Successfully"
                );
            } else {
                await axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}/trading-partner`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type":
                                "application/json",
                        },
                    }
                );

                toast.success(
                    "Company Created Successfully"
                );
            }

            navigate("/company-maslist");
        } catch (error) {
            console.error(error);
            toast.error(
                isEdit
                    ? "Failed To Update Company"
                    : "Failed To Create Company"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <div className="backgound-main-content p-4">
                <div className="container-fluid">

                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3 className="fw-bold mb-0">
                            {isEdit ? "Update Company" : "Create Company"}
                        </h3>
                    </div>

                    <form onSubmit={handleSubmit}>

                        {/* Basic Information */}
                        <div className="bg-white rounded  p-4 mb-4">

                            <h5 className="fw-bold mb-3">
                                Basic Information
                            </h5>

                            <div className="row g-3">

                                <div className="col-md-4">
                                    <label className="form-label">
                                        First Name
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">
                                        Middle Name
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="middleName"
                                        value={formData.middleName}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">
                                        Last Name
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Organization Name
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="organizationName"
                                        value={formData.organizationName}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        GST Number
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="gstNumber"
                                        value={formData.gstNumber}
                                        onChange={handleChange}
                                    />
                                </div>

                            </div>

                        </div>

                        {/* Contact Details */}
                        <div className="bg-white rounded  p-4 mb-4">

                            <h5 className="fw-bold mb-3">
                                Contact Details
                            </h5>

                            <div className="row g-3">

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Alternate Email
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="alternateEmail"
                                        value={formData.alternateEmail}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Mobile Number
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="mobileNumber"
                                        value={formData.mobileNumber}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Alternate Mobile Number
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="alternateMobileNumber"
                                        value={formData.alternateMobileNumber}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        GST Type
                                    </label>

                                    <select
                                        className="form-select"
                                        name="gstType"
                                        value={formData.gstType}
                                        onChange={handleChange}
                                    >
                                        <option value="INTER_STATE">
                                            INTER STATE
                                        </option>

                                        <option value="INTRA_STATE">
                                            INTRA STATE
                                        </option>
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        PartyType
                                    </label>

                                    <select
                                        className="form-select"
                                        name="partyType"
                                        value={formData.partyType}
                                        onChange={handleChange}
                                    >
                                        <option value="CUSTOMER">
                                            CUSTOMER
                                        </option>

                                        <option value="VENDOR">
                                            VENDOR
                                        </option>
                                    </select>
                                </div>

                            </div>

                        </div>

                        {/* Address Details */}
                        <div className="bg-white rounded  p-4 mb-4">

                            <h5 className="fw-bold mb-3">
                                Address Details
                            </h5>

                            <div className="row g-3">

                                <div className="col-md-4">
                                    <label className="form-label">
                                        Landmark
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="landMark"
                                        value={formData.address.landMark}
                                        onChange={handleAddressChange}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">
                                        Street Line 1
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="streetLine1"
                                        value={formData.address.streetLine1}
                                        onChange={handleAddressChange}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">
                                        Street Line 2
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="streetLine2"
                                        value={formData.address.streetLine2}
                                        onChange={handleAddressChange}
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">
                                        City
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="city"
                                        value={formData.address.city}
                                        onChange={handleAddressChange}
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">
                                        State
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="state"
                                        value={formData.address.state}
                                        onChange={handleAddressChange}
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">
                                        Postal Code
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="postalCode"
                                        value={formData.address.postalCode}
                                        onChange={handleAddressChange}
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">
                                        Country
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="country"
                                        value={formData.address.country}
                                        onChange={handleAddressChange}
                                    />
                                </div>

                                <div className="col-12">
                                    <label className="form-label">
                                        Metadata
                                    </label>

                                    <textarea
                                        className="form-control"
                                        rows="4"
                                        name="metadata"
                                        value={formData.address.metadata}
                                        onChange={handleAddressChange}
                                    />
                                </div>

                            </div>

                        </div>

                        {/* Buttons */}
                        <div className="d-flex justify-content-end gap-2">

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() =>
                                    navigate("/company-maslist")
                                }
                            >
                                Cancel
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading
                                    ? isEdit
                                        ? "Updating..."
                                        : "Saving..."
                                    : isEdit
                                        ? "Update Company"
                                        : "Save Company"}
                            </button>

                        </div>

                    </form>

                </div>
            </div>
        </Layout>
    );
};

export default CompanyMasterCreate;